// src/guidance/templates/theme.ts
import type { AppTheme } from '@/types/app';

export const baseTheme: AppTheme = {
  colors: { primary: '#F97316', secondary: '#C2410C', background: '#FFF8F1', surface: '#FFFFFF', text: '#1F2937', textSecondary: '#8A7E74', error: '#EF4444', success: '#16A34A', warning: '#F59E0B', border: '#F3E8DD' },
  spacing: { xs: 4, sm: 8, md: 16, lg: 24, xl: 32 },
  borderRadius: { sm: 6, md: 12, lg: 18, full: 9999 },
  typography: { h1: { fontSize: 32, fontWeight: '800' }, h2: { fontSize: 26, fontWeight: '800' }, h3: { fontSize: 22, fontWeight: '700' }, h4: { fontSize: 18, fontWeight: '700' }, h5: { fontSize: 16, fontWeight: '600' }, h6: { fontSize: 14, fontWeight: '600' }, body: { fontSize: 16, fontWeight: '400' }, caption: { fontSize: 12, fontWeight: '400' } },
} as AppTheme;

export function themed(primary: string, secondary: string): AppTheme {
  return { ...baseTheme, colors: { ...baseTheme.colors, primary, secondary } };
}
